export default __webpack_public_path__ + "static/media/Linkedin Learning Succeeding In Web Development.67e6b949.webp";